<template>
  <v-container class="pa-8">
    <v-data-table :headers="headers" 
    
    :sort-by="['descrizione']"
      :search="search"  
      :loading="loading"
    :items="clients" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Clienti</v-toolbar-title>        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
           <v-text-field
            v-model="search"
            class="mx-5"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field> 

          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                Nuovo
              </v-btn>
            </template>
            <v-card>

              <FrmEditCustomer
                ref="frmEditCustomer"
                v-bind:clientInfo="editedClient"
                v-on:customerAdded="customer_Added"
                v-on:customerUpdated="customer_Updated"
                v-on:close-dialog="closeDialog"
              ></FrmEditCustomer>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="frmEditCustomerSave_Click"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="700px">
            <v-card>
              <v-card-title class="headline"
                >Sei sicuro di voler rimuovere questo utente?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>

      <v-snackbar v-model="ShowSnackbar" :timeout="5000">
        {{ error }}

        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="error = ''">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-data-table>
    <div>
      <!-- <template>
        <v-btn color="error" class="mt-3" :to="{ name: 'dashboard' }">
          Indietro
        </v-btn>
      </template> -->
    </div>
    <!-- SEDE CLIENTE -->
  </v-container>
</template>
<script>
import EasyPlanClient from "../../utils/EasyPlanClient";

import FrmEditCustomer from "../../components/EditForms/FrmEditCustomer";
export default {
  components: { FrmEditCustomer },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    ShowSnackbar:false,
    radiobtnClientType: "",
    error: "",
    loading:false,
    search: "",
    headers: [
      { text: "Descrizione", value: "descrizione" },
     
      { text: "Telefono", value: "telefono" },
      { text: "Email", value: "mail" },

      { text: "Actions", value: "actions", sortable: false },
    ],
    sede: [],
    clients: [],
    editedIndex: -1,
    editedClient: {
      descrizione: "",
      indirizzo: "",
      cap: "",
      città: "",
      provincia: "",
      telefono: "",
      mail: "",
      sedi:[],

    },
    defaultItem: {
      descrizione: "",
      indirizzo: "",
      cap: "",
      città: "",
      provincia: "",
      telefono: "",
      mail: "",
       sedi:[],
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Client" : "Edit Client";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
       
    customer_Added(cust) {
      // this.loadCustomers();
      this.clients.push(cust);
      this.dialog = false;
    }, 
    customer_Updated(cust) {
      // this.loadCustomers();
      this.clients = this.clients.filter((c)=>cust.idCliente!=c.idCliente);
      this.clients.push(cust);
      this.dialog = false;
    },

    frmEditCustomerSave_Click: function () {
      // alert("save from manage clients");
      if (this.editedIndex > -1) {
        this.$refs.frmEditCustomer.editCustomer(this.editedClient,()=>{
          
          this.loadCustomers();
          this.closeDialog();
        });
      } else {
        this.$refs.frmEditCustomer.addClient(()=>{

          this.loadCustomers();
          this.closeDialog();
        });
        
      }
    },

    initialize() {
      if (
        localStorage.userToken == undefined ||
        localStorage.userToken == "null"
      ) {
        console.debug("logging off");
        localStorage.userToken = null;

        this.$router.push({
          name: "login",
          params: { companyAlias: this.$route.params.companyAlias },
        });
      }
      this.loadCustomers();
    },
    closeDialog: function () {
      this.dialog = false;
    },

    editItem: function (item) {
      console.log("editing customer from manage clients");
      
      
      this.editedIndex = this.clients.indexOf(item);
      this.editedClient = Object.assign({}, item);
      //this.$refs.frmEditCustomer.emptyHeadquarters();

      this.dialog = true;

      // console.log(this.sede, "THIS")
    },

    deleteItem(item) {
      this.editedIndex = this.clients.indexOf(item);
      this.editedClient = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
       EasyPlanClient.Customers.Delete(this.$route.params.companyAlias,
         this.editedClient.idCliente).then((res)=>{

          this.clients.splice(this.editedIndex, 1);
          this.closeDelete();
        });
    },
 

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedClient = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedClient = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        this.editCustomer(this.editedClient);
        Object.assign(this.clients[this.editedIndex], this.editedClient);
      } else {
        this.insertCustomer(this.editedClient);
      }
      this.close();
    },

    loadCustomers() {
      this.loading=true;
      console.log("loading customers...");
      EasyPlanClient.Customers.GetAll(this.$route.params.companyAlias)
        .then((res) => {
          this.clients = res.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        }).finally(()=>{
          this.loading=false;
        });
    },

    insertCustomer(customer) {
      EasyPlanClient.Customers.Insert(
        this.$route.params.companyAlias,
        customer.descrizione,
        customer.indirizzo,
        customer.cap,
        customer.città,
        customer.provincia,
        customer.telefono,
        customer.mail,
        customer.sedi
      )
        .then((res) => {
          console.debug("risposta add customer:");
          console.debug(res);
          this.clients.push(res.data.data);
          this.loadCustomers();

          (customer.descrizione = ""),
            (customer.indirizzo = ""),
            (customer.cap = ""),
            (customer.città = ""),
            (customer.provincia = ""),
            (customer.telefono = ""),
            (customer.mail = "");
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });

      this.dialog = false;
    },

    editCustomer(customer) {
      EasyPlanClient.Customers.Update(this.$route.params.companyAlias, customer)
        .then((res) => {
          console.debug("risposta edit customer:");
          console.debug(res);
          this.loadCustomers();
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
  },
};
</script>